// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"48":"84a7a1e7","64":"3e730f09","80":"7e0611f0","205":"cf1186a3","773":"1804a90b","850":"575da777","970":"b2aba208","985":"fbeff7d7","996":"22f6d470"}[chunkId] + ".js";
};